import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AlertHistoryResponse, AlertResponse } from '@entities/alert';
import { ApiService } from '@services/api.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DashboardService {
  constructor(private api: ApiService) {}

  /**
   * 最新情報を取得する
   * @returns デバイスの最新情報
   */
  findLatestList(): Observable<AlertResponse[]> {
    const url = `/alerts/latest`;
    return this.api.get<AlertResponse[]>(url);
  }

  /**
   * 履歴情報を取得する
   * @returns デバイスの履歴情報
   */
  findHistoryList(
    historyFrom?: string,
    historyTo?: string,
  ): Observable<AlertHistoryResponse> {
    const url = `/alerts/history`;

    // クエリストリングを追加
    let params = new HttpParams();
    if (historyFrom) {
      params = params.set('history_from', historyFrom);
    }
    if (historyTo) {
      params = params.set('history_to', historyTo);
    }

    return this.api.get<AlertHistoryResponse>(url, { params });
  }
}
